import $ from "jquery";

import "../../components/desktop/setup";
import "../../components/desktop/booking";
import { loadLegacyPlugins } from "../../components/desktop/legacy_plugins";
import {
  initPostBookingTracking,
  initAncillaryOptionsTracking,
  initAncillaryAjaxTracking
} from "../../app/helpers/classes/post_booking_tracking";

initPostBookingTracking();
initAncillaryOptionsTracking();
// Desktop loads rails-ujs from webpack, so it fires on this same jQuery.
initAncillaryAjaxTracking($);

$(function () {
  // The rebuilt booking confirmation page (marked .tw-page, see
  // booking.html.erb) replaces the fancybox init and baggage-form
  // validation below with the booking-support-modal / late-baggage
  // Stimulus controllers. show_booking.html.erb and booking#hotel are not
  // rebuilt and still need this to run.
  if (document.querySelector(".tw-page[data-controller='booking-support-modal']")) {
    return;
  }

  // Same lazy fetch as components/desktop/booking's own plugin use -- past
  // the .tw-page return above, so this is one of the pages still on the old
  // markup. Without it this threw "$(...).fancybox is not a function" on
  // /visa_bokning, because fancybox is no longer in every bundle.
  loadLegacyPlugins().then(() => $(".fancybox").fancybox());

  // open booking modal
  // document.getElementById("hidden_hotel_link").click();

  $('#baggage-form').on('submit', function(e) {
    var checkboxes = $('#baggage-form input[type="checkbox"]:checked').length;

    if(checkboxes < 1){
      alert(checkboxes);
      e.preventDefault();
      return false;
    }
    return true;
  });
});
